import { css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Typography } from 'chatie-design-system';

import Modal, { ModalButton, ModalProps } from '../common/Modal';

const descriptionCSS = css`
  ${Typography.body14};
  word-break: keep-all;
`;

export const HonorPartnershipStoryInfoModal = (props: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} title={t('명예 작품 안내')}>
      <p className="multiline" css={descriptionCSS}>
        {t(
          '해당 작품은 작가가 명예 작가로 활동하는 동안 회차를 발행할 작품으로 선정한 작품입니다.'
        )}
      </p>
      <ModalButton text={t('확인')} />
    </Modal>
  );
};

export const OriginalStoryInfoModal = (props: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} title={t('오리지널 작품 안내')}>
      <p className="multiline" css={descriptionCSS}>
        {t('해당 작품은 채티에서 정식으로 라이센스 계약한 작품입니다.')}
      </p>
      <ModalButton text={t('확인')} />
    </Modal>
  );
};
